import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsVelomobileNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16.938 23h-1.925c-2.152 0-4.276-.493-6.207-1.44A4.502 4.502 0 010 20.25V9.671c0-.449.224-.924.684-1.19C1.288 8.133 3.681 7 9.281 7c5.203 0 10.319 1.572 14.36 3.822 3.984 2.218 7.168 5.238 8.162 8.312.36 1.116.001 2.152-.692 2.848-.659.662-1.603 1.018-2.553 1.018h-4.496c-.823 1.065-2.112 1.75-3.562 1.75s-2.74-.685-3.562-1.75zM5.478 9.722c-1.486.192-2.438.471-2.978.673v7.355h.944c2.205 0 4.379.517 6.347 1.509a11.603 11.603 0 005.222 1.241h.994a4.5 4.5 0 118.986 0h3.565c.355 0 .639-.139.782-.282a.354.354 0 00.098-.152c.007-.025.015-.074-.014-.163-.705-2.18-3.223-4.794-7-6.897L22.412 13 20.543 15H8.811zm.982 10.927a11.603 11.603 0 00-3.016-.399H2.5a2 2 0 003.96.399zM8.302 9.513L10.19 12.5h9.268l.615-.659C16.815 10.416 13.055 9.5 9.28 9.5c-.34 0-.666.004-.979.013zM20.5 18.25a2 2 0 100 4 2 2 0 000-4z"
        fill=""
      />
    </svg>
  )
);
SvgSportsVelomobileNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsVelomobileNormalMedium;
